var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @mui
import { autocompleteClasses } from '@mui/material/Autocomplete';
import { checkboxClasses } from '@mui/material/Checkbox';
import { dividerClasses } from '@mui/material/Divider';
import { menuItemClasses } from '@mui/material/MenuItem';
import { alpha } from '@mui/material/styles';
// ----------------------------------------------------------------------
export var paper = function (_a) {
    var theme = _a.theme, bgcolor = _a.bgcolor, dropdown = _a.dropdown;
    return (__assign(__assign(__assign(__assign({}, bgBlur(__assign({ blur: 20, opacity: 0.9, color: theme.palette.background.paper }, (!!bgcolor && {
        color: bgcolor
    })))), { backgroundImage: 'url(/assets/cyan-blur.png), url(/assets/red-blur.png)', backgroundRepeat: 'no-repeat, no-repeat', backgroundPosition: 'top right, left bottom', backgroundSize: '50%, 50%' }), (theme.direction === 'rtl' && {
        backgroundPosition: 'top left, right bottom'
    })), (dropdown && {
        padding: theme.spacing(0.5),
        boxShadow: theme.customShadows.dropdown,
        borderRadius: Number(theme.shape.borderRadius) * 1.25
    })));
};
// ----------------------------------------------------------------------
export var menuItem = function (theme) {
    var _a;
    return (__assign(__assign({}, theme.typography.body2), (_a = { padding: theme.spacing(0.75, 1), '&:not(:last-of-type)': {
                marginBottom: 4
            }, minHeight: 'auto' }, _a["&.".concat(menuItemClasses.selected)] = {
        fontWeight: theme.typography.fontWeightSemiBold,
        backgroundColor: theme.palette.action.selected,
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    }, _a["& .".concat(checkboxClasses.root)] = {
        padding: theme.spacing(0.5),
        marginLeft: theme.spacing(-0.5),
        marginRight: theme.spacing(0.5)
    }, _a["&.".concat(autocompleteClasses.option, "[aria-selected=\"true\"]")] = {
        backgroundColor: theme.palette.action.selected,
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    }, _a["&+.".concat(dividerClasses.root)] = {
        margin: theme.spacing(0.5, 0)
    }, _a)));
};
export function bgBlur(props) {
    var color = (props === null || props === void 0 ? void 0 : props.color) || '#000000';
    var blur = (props === null || props === void 0 ? void 0 : props.blur) || 6;
    var opacity = (props === null || props === void 0 ? void 0 : props.opacity) || 0.8;
    var imgUrl = props === null || props === void 0 ? void 0 : props.imgUrl;
    if (imgUrl) {
        return {
            position: 'relative',
            backgroundImage: "url(".concat(imgUrl, ")"),
            '&:before': {
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 9,
                content: '""',
                width: '100%',
                height: '100%',
                backdropFilter: "blur(".concat(blur, "px)"),
                WebkitBackdropFilter: "blur(".concat(blur, "px)"),
                backgroundColor: alpha(color, opacity)
            }
        };
    }
    return {
        backdropFilter: "blur(".concat(blur, "px)"),
        WebkitBackdropFilter: "blur(".concat(blur, "px)"),
        backgroundColor: alpha(color, opacity)
    };
}
export function bgGradient(props) {
    var direction = (props === null || props === void 0 ? void 0 : props.direction) || 'to bottom';
    var startColor = props === null || props === void 0 ? void 0 : props.startColor;
    var endColor = props === null || props === void 0 ? void 0 : props.endColor;
    var imgUrl = props === null || props === void 0 ? void 0 : props.imgUrl;
    var color = props === null || props === void 0 ? void 0 : props.color;
    if (imgUrl) {
        return {
            background: "linear-gradient(".concat(direction, ", ").concat(startColor || color, ", ").concat(endColor || color, "), url(").concat(imgUrl, ")"),
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center'
        };
    }
    return {
        background: "linear-gradient(".concat(direction, ", ").concat(startColor, ", ").concat(endColor, ")")
    };
}
// ----------------------------------------------------------------------
export function textGradient(value) {
    return {
        background: "-webkit-linear-gradient(".concat(value, ")"),
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
    };
}
// ----------------------------------------------------------------------
export var hideScroll = {
    x: {
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        overflowX: 'scroll',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    y: {
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        overflowY: 'scroll',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    }
};
